import api from '../token';

export const ListTurno = async () => {
  try {
    const response = await api.post('/getTurno');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

